import { ModalContainerSize } from "themes/default-tailwind"
import { ReactElement } from "react"
import { ButtonDestructive, ButtonTertiary } from "@nova/component-btn"
import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import * as Icons from "@nova/component-icons"

type TwoWayDecisionModalProps = {
    children?: ReactElement
    title?: string
    description?: string
    size?: ModalContainerSize
    firstLabel?: string
    secondLabel?: string
    firstHandler: VoidFunction
    secondHandler: VoidFunction
    className?: string
    closeModal?: () => void
}

/**
 * provides the container that will render the title and description as well as the choice buttons for displaying a two way (usually Yes/No) decision modal
 */
export const TwoWayDecisionModalContent = ({
    title,
    description,
    firstLabel = "Yes",
    secondLabel = "No",
    firstHandler,
    secondHandler,
    closeModal,
}: TwoWayDecisionModalProps) => {
    return (
        <HighPriorityNovaModalContainer
            title={title || ""}
            closeModal={closeModal}
            bottomBar={
                <div className="w-full flex justify-end items-center gap-2">
                    <ButtonTertiary title={secondLabel} onClick={secondHandler} />
                    <ButtonDestructive
                        RightIcon={Icons.Trash}
                        title={firstLabel}
                        onClick={firstHandler}
                    />
                </div>
            }
            className="backdrop-blur-[20px] w-[30rem]"
        >
            {description && (
                <h4
                    id="modal-content-description"
                    className="whitespace-pre-line text-center"
                    dangerouslySetInnerHTML={{ __html: description }}
                />
            )}
        </HighPriorityNovaModalContainer>
    )
}

export default TwoWayDecisionModalContent
